import { Outlet } from "react-router-dom";
import JobsHeader from "./JobsHeader";
import "./Joblayout.css"; // Assuming you have a CSS file for styling
import { useState } from "react";
import Sidebar from "./Sidebar";
import {FiMenu} from "react-icons/fi";

const JobsLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };
  return (
    <div className="job-layout-container">
      <JobsHeader>
        {/* Toggle Button For Small Screens */}
        <button
            className="job-sidebar-toggle-btn"
            onClick={toggleSidebar}
            aria-label="Toggle Sidebar"
        >
          <FiMenu size={24} />
        </button>
      </JobsHeader>
      <div className="job-layout-content">
        <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
        <main className="job-layout-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default JobsLayout;
